import React, { useState } from 'react';
import { useLogin, useNotify } from 'react-admin';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export const CustomLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const login = useLogin();
  const notify = useNotify();

  const handleLoginSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login({ username: email, password });
    } catch (error: any) {
      const errorMessage = typeof error === 'string'
        ? error
        : error?.message || 'Incorrect email or password';
      
      // Показываем понятное сообщение об ошибке
      notify(errorMessage, { type: 'error' });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#FFF9ED',
        padding: 2,
      }}
    >
      {/* Заголовок над карточкой */}
      <Box sx={{ marginBottom: 4, textAlign: 'center' }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: '#3F5F4F',
            fontWeight: 600,
            marginBottom: 1,
          }}
        >
          The Mind Admin
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#3F5F4F',
            opacity: 0.8,
            fontSize: '1rem',
          }}
        >
          Guided by Prof. Fred Luskin's wisdom
        </Typography>
      </Box>

      <Card
        sx={{
          minWidth: 400,
          maxWidth: 450,
          backgroundColor: '#FFF9ED',
          border: '1px solid #e0e0e0',
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <CardContent sx={{ padding: 4 }}>
          {/* Заголовок */}
          <Typography
            variant="h5"
            component="h2"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 700,
              marginBottom: 3,
              color: '#3F5F4F',
            }}
          >
            Welcome Back
          </Typography>

          {/* form login */}
          <form onSubmit={handleLoginSubmit}>
            <TextField
              fullWidth
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              autoComplete="email"
              variant="outlined"
              sx={{
                marginBottom: 2,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1,
                  backgroundColor: '#FFF9ED',
                  '& fieldset': {
                    borderColor: '#d0d0d0',
                    borderWidth: '1px',
                  },
                  '&:hover fieldset': {
                    borderColor: '#b0b0b0',
                  },
                  '&.Mui-focused fieldset': {
                    borderWidth: '2px',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: '#666',
                  backgroundColor: '#FFF9ED',
                  padding: '0 4px',
                  '&.Mui-focused': {
                    color: '#1976d2',
                  },
                  '&.MuiInputLabel-shrink': {
                    transform: 'translate(14px, -9px) scale(0.75)',
                  },
                },
                '& .MuiOutlinedInput-input': {
                  color: '#000000',
                  padding: '14px',
                },
              }}
            />

            <TextField
              fullWidth
              label="Password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              autoComplete="current-password"
              variant="outlined"
              placeholder="Enter your password"
              sx={{
                marginBottom: 3,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1,
                  backgroundColor: '#FFF9ED',
                  '& fieldset': {
                    borderColor: '#d0d0d0',
                    borderWidth: '1px',
                  },
                  '&:hover fieldset': {
                    borderColor: '#b0b0b0',
                  },
                  '&.Mui-focused fieldset': {
                    borderWidth: '2px',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: '#666',
                  backgroundColor: '#FFF9ED',
                  padding: '0 4px',
                  '&.Mui-focused': {
                    color: '#1976d2',
                  },
                  '&.MuiInputLabel-shrink': {
                    transform: 'translate(14px, -9px) scale(0.75)',
                  },
                },
                '& .MuiOutlinedInput-input': {
                  color: '#000000',
                  padding: '14px',
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{
                  marginTop: 2,
                  marginBottom: 2,
                  padding: 1.5,
                  borderRadius: 1,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  backgroundColor: '#3F5F4F',
                  color: '#FFF9ED',
                  '&:hover': {
                    backgroundColor: '#2d4739',
                  },
                }}
              >
                Sign In
              </Button>
            </form>
        </CardContent>
      </Card>
    </Box>
  );
};

